import type ReceivedQuestionnaire from "./receivedQuestionnaire";

export default class ReceivedQuestionnaires {
  questionnaires = new Array<ReceivedQuestionnaire>();
}
